import Header from "../components/core/Header";
import usePageMeta from '../utils/usePageMeta';
import pagesSeo from '../data/pagesSeo.json';
import Footer from "../components/core/Footer";
import styles from "./GalleryPage.module.css";
import typography from '../theme/typography';
import colors from '../theme/colors';

const GalleryPage = () => {
  usePageMeta(pagesSeo.gallery);
  return (
    <div className={styles.page}>
      <Header />

      <section className={styles.gallerySection}>
        <div className={styles.container}>
          <h1 className={`${styles.pageTitle} page-primary-title`} style={{ ...typography.heading.large, color: colors.dark }}>
            GALLERY
          </h1>
          <hr className={styles.divider} />
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default GalleryPage;
